import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'intersection-observer' // Optional
import Vue from "vue";
import store from "../../shared/store/index.js";
import Vue2Filters from 'vue2-filters'
import BootstrapVue from 'bootstrap-vue'
import Toasted from 'vue-toasted';

import components from "../../shared/components.js";
import gtmClickTracking from '../../shared/components/mixins/gtmClickTracking'

// Enable if using Vue Devtools for debuging. For more info see:
// https://vuejs.org/v2/guide/installation.html#Vue-Devtools
// Vue.config.devtools = true

Vue.use(Vue2Filters)
Vue.use(BootstrapVue)
Vue.use(Toasted)
Vue.mixin(gtmClickTracking)

require("../../shared/styles.scss");

Vue.config.ignoredElements = ['bootstrap']

Vue.component('global-modals', components.GlobalModals);
Vue.component('reservation-display', components.ReservationDisplay);
Vue.component('coupon-card', components.CouponCard);
Vue.component('past-purchases', components.PastPurchases);
Vue.component('add-to-bucket', components.AddToBucket);
Vue.component('preference-add-to-bucket', components.PreferenceAddToBucket);
Vue.component('error-container', components.Errors);
Vue.component('product-card', components.ProductCard);
Vue.component('shopping-list-typeahead', components.ShoppingListTypeahead);
Vue.component('modal-once-per-session', components.ModalOncePerSession);
Vue.component('notice-representative-product', components.NoticeRepresentativeProduct);

Vue.config.productionTip = false;

// Lets .js files use new Vue();
window.Vue = Vue

/*
* Looks for each .vue-instance-init and triggers Vue on the components within
* @global
* Made available globally so it can re-init after ajax calls
*/
window.initVueInstances = function initVueInstances(){
    var vues = document.querySelectorAll(".vue-instance-init:not(.initialized)");
    Array.prototype.forEach.call(
        vues,
        (el, index) => {
            el.classList.add("initialized")

            window['VueInstance' + index] =  new Vue({
                el,
                store,
                data: { message: "vue instance " + index },
            });

            // Creates window.VueStore so we can use VueStore.$store.state
            if(index == 0) window.VueStore = VueInstance0
        }
    );
}
initVueInstances();